import React, { useCallback } from "react";
import { UploadIcon } from "@heroicons/react/outline";

type Props = {
  iconSrc?: string;
  imageSrc?: string;
  onSelectImage?: () => void;
  onSelectIcon?: () => void;
};

const ImageSelector = React.memo(
  ({ imageSrc, iconSrc, onSelectImage, onSelectIcon }: Props) => {
    const onIconClick = useCallback(
      (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();
        onSelectIcon && onSelectIcon();
      },
      [onSelectIcon]
    );

    
    return (
      <div className="flex flex-col relative"> 
        <div
          className="w-36 h-36 flex flex-col items-center justify-center cursor-pointer absolute border-solid border-black border-4 rounded-md bg-gray-400 right-10 top-4 bg-full"
          role="button"
          style={{
            backgroundImage: `url('${iconSrc}')`,
            backgroundPosition:`center`,
            backgroundSize:`cover`
          }}
          onClick={onIconClick}
        >
          {!iconSrc && (
            <div className="flex flex-col items-center">
              <UploadIcon className="h-10 w-10 text-gray-600" />
              <span className="text-xs text-black font-semibold">
                THUMBNAIL
              </span>
              <span className="text-xs text-black font-semibold">
                (REQUIRED)
              </span>
            </div>
          )}
        </div>

        <h4 className="font-black text-md md:text-3xl text-left mt-8 mb-4">
          THUMBNAIL AND FEATURED BANNER IMAGE
        </h4>
        <div
          className="flex flex-col flex-1 items-center justify-center bg-gray-400 border-solid border-black border-4 bg-full cursor-pointer"
          role="button"
          onClick={onSelectImage}
        >
          {imageSrc ? (
            <img alt={`banner ${imageSrc}`} src={imageSrc} />
          ) : (
            <div className="flex flex-1 w-16 h-16 flex flex-col items-center justify-center">
              {!imageSrc && (
                <div className="flex flex-col items-center p-2 text-center">
                  <UploadIcon className="h-10 w-10 text-gray-600" />
                  <span className="text-xs text-black font-semibold">
                    FEATURED BANNER
                  </span>
                  <span className="text-xs text-black font-semibold">
                    (OPTIONAL)
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default ImageSelector;
